import { render, staticRenderFns } from "./2-6.ImportInsurance.vue?vue&type=template&id=6361c27a"
import script from "./2-6.ImportInsurance.vue?vue&type=script&lang=js"
export * from "./2-6.ImportInsurance.vue?vue&type=script&lang=js"
import style0 from "./2-6.ImportInsurance.vue?vue&type=style&index=0&id=6361c27a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports